import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getDynamicPage } from '../../services'
import { DynamicPageQueryKeys } from '@/modules/client-setting/keys'
import {
	GetDynamicPageRequest,
	GetDynamicPageResponse,
} from '@/modules/client-setting/type'

export default function useQueryGetDynamicPage(
	payload: GetDynamicPageRequest,
	props?: UseBaseQueryOptions<GetDynamicPageResponse>,
) {
	return useQuery({
		queryKey: [DynamicPageQueryKeys.GetDynamicPage, payload],
		queryFn: () => getDynamicPage(payload),
		...props,
	})
}
